import { connect } from 'react-redux';
import AudioChunkBuffer from './AudioChunkBuffer';
const mapStateToProps = ({ scribeSession: { url, currentPlatform }, scribeConversation: { sampleRateHertz, chunkLengthMs, id: conversationId, isInConversation }, scribeTranscriptUI: { delay }, }) => ({
    chunkLengthMs,
    conversationId,
    currentPlatform,
    delay,
    isInConversation,
    sampleRateHertz,
    sessionSocketUrl: url,
});
export default connect(mapStateToProps)(AudioChunkBuffer);
